import React, { useState } from "react";
import ReusableTable from "../../../../../components/PagesComponents/Financial/CashOutFlow/Charity/Reusable.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import FormInput from "../../../../../components/Universal/FormInput.component";
import { Formik } from "formik";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import DetailsView from "../../../../../components/PagesComponents/Financial/CashOutFlow/Charity/DetailsView.component";

const Body = ({
  communityOutreachColumn,
  communityOutreachDonation,
  coordinators = [],
  verifiers = [],
}) => {
  const [model, openModel] = useState(false);
  const onClose = () => {
    openModel(false);
  };
  return (
    <div
      style={{ display: "flex", margin: "1rem", gap: "1rem" }}
      className="EducationalMaterialContainer"
    >
      <ScrollableModal isOpen={model} onClose={onClose}>
        <DetailsView
          onClose={onClose}
          highlightKey="donationId"
          data={{
            "Donation id": "2398476282",
            "Scheme name": "Siksha vikash",
            "Community name": "Blind People",
            "Outreach for": "Education for blind people",
            "Eqvt. amount (INR)": "₹ 23,45",
            Coordinator: "Rafik Haldar",
            "Verified by": "Javed Habib",
          }}
          description="Inspection is near about two hours within a campus. Mainly school building. It touches a world class standard."
        />
      </ScrollableModal>
      <div
        style={{ background: "white", padding: "1rem", borderRadius: "10px" }}
        className="formContaienr"
      >
        <h2
          style={{
            color: "var(--grayColor)",
            fontWeight: "400",
            borderBottom: "1px solid var(--borderGray)",
            paddingBottom: "1rem",
          }}
          className="form-title"
        >
          Add the cost for community outreach
        </h2>
        <div>
          <Formik
            initialValues={{
              schemeName: "",
              description: "",
              community: "",
              outreach: "",
              equivalentCost: "",
              coordinator: "",
              verifier: "",
            }}
            onSubmit={(values) => {
              console.log("Submitted:", values);
              openModel(true);
            }}
          >
            {({
              values,
              setFieldValue,
              handleSubmit,
              touched,
              errors,
              setTouched,
            }) => {
              return (
                <form onSubmit={handleSubmit} className="p-1">
                  {/* First Row */}
                  <div className="grid grid-cols-2 gap-4 mb-5">
                    <FormInput
                      label="Scheme name"
                      type="text"
                      name="schemeName"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter the scheme name"
                      setFieldValue={(e) =>
                        setFieldValue("schemeName", e.target.value)
                      }
                    />

                    <FormInput
                      label="Description"
                      type="text"
                      name="description"
                      touched={touched}
                      errors={errors}
                      placeholder="Type something here"
                      setFieldValue={(e) =>
                        setFieldValue("description", e.target.value)
                      }
                    />

                    <FormInput
                      label="Particular community"
                      type="text"
                      name="community"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter community name"
                      setFieldValue={(e) =>
                        setFieldValue("community", e.target.value)
                      }
                    />

                    <FormInput
                      label="Outreach for"
                      type="text"
                      name="outreach"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter outreach for"
                      setFieldValue={(e) =>
                        setFieldValue("outreach", e.target.value)
                      }
                    />

                    <FormInput
                      label="Equivalent cost (INR)"
                      type="number"
                      name="equivalentCost"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter total cost"
                      setFieldValue={(e) =>
                        setFieldValue("equivalentCost", e.target.value)
                      }
                    />

                    <DropDownInput
                      name="coordinator"
                      label="Coordinator"
                      value={values.coordinator}
                      placeholder="Choose a coordinator"
                      suggestionList={coordinators}
                      setFieldValue={(val) => setFieldValue("coordinator", val)}
                    />

                    <DropDownInput
                      name="verifier"
                      label="Verifier"
                      value={values.verifier}
                      placeholder="Choose payment verifier"
                      suggestionList={verifiers}
                      setFieldValue={(val) => setFieldValue("verifier", val)}
                    />
                  </div>

                  {/* Submit */}
                  <button type="submit" className="actionBtn w-full mt-1">
                    Confirm
                  </button>
                </form>
              );
            }}
          </Formik>
        </div>
      </div>
      <ReusableTable
        title="List of community outreach"
        countLabel={`${communityOutreachDonation.length} times`}
        columns={communityOutreachColumn}
        data={communityOutreachDonation}
        renderedElement={
          <div
            style={{ marginLeft: "auto", marginTop: "1rem" }}
            className="lightBlueInfoBox"
          >
            <span className="info-title">
              Total Educational material donation amount:
            </span>{" "}
            ₹ 2,60,560
          </div>
        }
        gridColumnStyle="1fr 1fr 1fr"
      />
    </div>
  );
};

export default Body;
